import { Grid2, Typography } from "@mui/material";
import { Fragment } from "react";
import { timeDiff } from "../../../../../../utility/misc/humanizers";

const UIText = {
  "es-CL": { label: "Intervalo de respaldo" },
  "en-US": { label: "Backup intervalo" },
};

const Interval = ({ scan_interval, locale }) => {
  const { label } = UIText[locale];

  return (
    <Fragment>
      <Grid2 container size={6}>
        <Typography>{label}</Typography>
      </Grid2>
      <Grid2 container size={6}>
        <Typography>
          {scan_interval % 15 ? "~" : ""}
          {timeDiff(scan_interval * 60 * 1000)}
        </Typography>
      </Grid2>
    </Fragment>
  );
};

export default Interval;
